module.exports = __webpack_public_path__ + "static/media/meanreverting.4a529aad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/meanreverting.svg
// module id = 587
// module chunks = 0